import { AxiosAPI } from "../api";

// Calls
export function publishProject(projectId: string): Promise<string> {
  return AxiosAPI.post(`/publications`, { projectId });
}
